import memoize from 'lodash.memoize';
import { sanitiseLocale } from './sanitiseLocale';

const formatNumber = (number, locale) => {
    const sanitisedLocale = sanitiseLocale(locale);

    return Intl.NumberFormat(sanitisedLocale).format(number);
};

const resolve = (number, locale) => `${number}/${locale}`;

export default memoize(formatNumber, resolve);
